/**
 * Catálogo de planes por módulo.
 */
import { z } from "zod";
import { PATTERNS } from "./constants.js";
import { FeatureValueSchema } from "./entitlements.js";
export const BillingModelSchema = z.enum(["flat", "per_seat"]);
export const PlanStatusSchema = z.enum(["active", "legacy", "hidden"]);
export const PlanSchema = z.object({
    id: z.uuid(),
    moduleCode: z.string().regex(PATTERNS.MODULE_CODE),
    code: z.string().regex(PATTERNS.KEY),
    name: z.string(),
    description: z.string().nullable(),
    priceMonthly: z.string().regex(/^\d+(\.\d{1,2})?$/),
    currency: z.string().length(3),
    billingModel: BillingModelSchema,
    status: PlanStatusSchema,
    sortOrder: z.number().int(),
    features: z.record(z.string().regex(PATTERNS.KEY), FeatureValueSchema),
    /** limitKey → máximo (null = ilimitado). */
    limits: z.record(z.string().regex(PATTERNS.KEY), z.number().nullable()),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
//# sourceMappingURL=plans.js.map